import { ChartController as controller } from './chart.controller';
import template from './chart.html';

export const chartComponent = {
  name: 'chartComponent',
  restrict: 'E',
  transclude: true,
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    chartData: '<',
    chartTypes: '<',
    currentChartType: '<',
    excludedFilters: '<',
    onSwitchChart: '&',
    onToggleFilter: '&'
  }
};
